import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import { get, post, put } from "../../../utils/apiUtils";
import TextArea from "antd/es/input/TextArea";
import { getUserRole } from "../../../hooks/getUserRoles";
import GeneralButton from "../../../components/GeneralButton"; // adjust path if needed
import { useTranslation } from "react-i18next";

const { Option } = Select;

function WorkspaceModal({
  visible,
  onCancel,
  onCreate,
  workspaceId,
  mode,
}: any) {
  const { t } = useTranslation("workspaces");
  const [form] = Form.useForm();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const userRole = getUserRole();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get<any>("countries/");
        setCountries(response.data);
      } catch (error) {
        message.error(t("loadCountriesFailed"));
      }
    };
    fetchCountries();
  }, []);

  const fetchWorkspaceDetails = async () => {
    if (["edit", "view"].includes(mode) && workspaceId) {
      try {
        const response = await get<any>(`get-workspace-by-id/${workspaceId}`);
        if (response?.type === "success") {
          const { name, description, organization_id, country_ids } =
            response.data;
          form.setFieldsValue({
            name,
            description,
            organization_id,
            country_ids,
          });
        } else {
          message.error(t("modal.fetchDetailsFailed") + " " + response.type);
        }
      } catch (error: any) {
        message.error(t("modal.fetchDetailsFailed") + " " + error.message);
      }
    }
  };

  useEffect(() => {
    fetchWorkspaceDetails();
  }, [workspaceId, mode]);

  let organization_id = localStorage.getItem("organizationId");

  const handleSubmit = async (values: any) => {
    setLoading(true);

    if (mode === "edit") {
      try {
        const response = await put<any>(`workspaces/${workspaceId}`, {
          name: values.name,
          description: values.description,
          country_ids: values.country_ids,
        });
        if (response.type === "success") {
          message.success(t("modal.updateSuccess"));
          // onCreate(values);
          onCreate(response.data);
          fetchWorkspaceDetails();
        } else {
          message.error(response.type);
        }
      } catch (error: any) {
        message.error(t("modal.updateFailed") + " " + error.message);
      }
    } else {
      try {
        const response = await post<any>(
          `workspaces/?organization_id=${organization_id}`,
          {
            name: values.name,
            description: values.description,
            country_ids: values.country_ids,
          }
        );
        if (response?.type === "success") {
          message.success(t("modal.createSuccess"));
          const createdWorkspace = response.data;
          form.resetFields();
          onCreate(createdWorkspace);

          // onCreate(values);
        }
      } catch (error: any) {
        message.error(t("modal.createFailed") + " " + error.message);
      }
    }

    setLoading(false);
    form.resetFields();
    onCancel();
  };

  useEffect(() => {
    if (visible && mode === "create") {
      form.resetFields();
    }
  }, [visible, mode]);

  return (
    <Modal
      open={visible}
      title={
        mode === "edit"
          ? t("modal.editTitle")
          : mode === "view"
          ? t("modal.viewTitle")
          : t("modal.createTitle")
      }
      className="addEdit-workspace-modal"
      onCancel={onCancel}
      footer={
        mode === "view" ? (
          <GeneralButton variant="default" onClick={onCancel}>
            {t("modal.close")}
          </GeneralButton>
        ) : (
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
          >
            <GeneralButton
              variant="default"
              onClick={onCancel}
              style={{ height: "44px" }}
            >
              {t("modal.cancel")}
            </GeneralButton>
            <GeneralButton
              variant="primary"
              loading={loading}
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    handleSubmit(values);
                  })
                  .catch((info) => {
                    console.log("Validate Failed:", info);
                  });
              }}
              style={{ height: "44px" }}
            >
              {mode === "edit" ? t("modal.saveChanges") : t("modal.addWorkspace")}
            </GeneralButton>
          </div>
        )
      }
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{ modifier: "public" }}
      >
        <Form.Item
          name="name"
          label={t("modal.nameLabel")}
          rules={[
            {
              required: true,
              message: t("modal.nameRequired"),
            },
          ]}
        >
          <Input placeholder={t("modal.namePlaceholder")} />
        </Form.Item>
        <Form.Item name="description" label={t("modal.descriptionLabel")}>
          <TextArea rows={4} placeholder={t("modal.descriptionPlaceholder")} />
        </Form.Item>
        <Form.Item
          name="country_ids"
          label={t("modal.countriesLabel")}
          rules={[
            { required: true, message: t("modal.countriesRequired") },
          ]}
        >
          <Select
            showSearch
            placeholder={t("modal.countriesPlaceholder")}
            mode="multiple"
            filterOption={(input: any, option: any) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {countries.map((country: any) => (
              <Option key={country.id} value={country.id}>
                {country.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default WorkspaceModal;
